import React from "react";
import { DIMENSIONS } from "../../governance/govData";

// Lightweight SVG radar chart. size px, values {dim: 0-100}.
export default function Radar({ values, size = 300 }) {
  const cx = size / 2, cy = size / 2, r = size / 2 - 34;
  const n = DIMENSIONS.length;
  const pt = (i, radius) => {
    const ang = (Math.PI * 2 * i) / n - Math.PI / 2;
    return [cx + radius * Math.cos(ang), cy + radius * Math.sin(ang)];
  };
  const rings = [0.25, 0.5, 0.75, 1];
  const poly = DIMENSIONS.map((d, i) => pt(i, (r * (values[d] || 0)) / 100).join(",")).join(" ");
  return (
    <svg viewBox={`0 0 ${size} ${size}`} className="w-full max-w-[340px] mx-auto" role="img" aria-label="Governance maturity radar">
      {rings.map((rr) => (
        <polygon key={rr} points={DIMENSIONS.map((_, j) => pt(j, r * rr).join(",")).join(" ")} fill="none" stroke="rgba(255,255,255,0.08)" />
      ))}
      {DIMENSIONS.map((d, i) => { const [x, y] = pt(i, r); return <line key={d} x1={cx} y1={cy} x2={x} y2={y} stroke="rgba(255,255,255,0.08)" />; })}
      <polygon points={poly} fill="rgba(56,217,240,0.18)" stroke="#38d9f0" strokeWidth="2" />
      {DIMENSIONS.map((d, i) => {
        const [x, y] = pt(i, r + 18);
        return <text key={d} x={x} y={y} fontSize="9" fill="rgba(255,255,255,0.7)" textAnchor="middle" dominantBaseline="middle">{d}</text>;
      })}
    </svg>
  );
}
